import { render, staticRenderFns } from "./jefeszona_F.vue?vue&type=template&id=c50c2712"
import script from "./jefeszona_F.vue?vue&type=script&lang=js"
export * from "./jefeszona_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports